module.exports = __webpack_public_path__ + "static/logo-1386762941302c431fcb76170714ba6b.jpeg";